<template>
  <Transition name="fade">
    <div
      v-if="isOpen"
      class="ui-popup-col"
    >
      <div
        :style="{width: `${width}px`}"
        class="ui-popup-col__content"
      >
        <div class="ui-popup-col__head">
          <slot name="title">
            {{ title }}
          </slot>
          <UiIcon
            :size="19"
            name="times"
            class="ui-popup-col__head-icon"
            @click="() => {
              if (escClose) {
                close(); $emit('cancel');
                return
              }
              cancel()
            }"
          />
        </div>
        <div class="ui-popup-col__body">
          <slot />
        </div>
        <div class="ui-popup-col__controls">
          <slot name="controls">
            <div class="ui-popup-col__controls-block">
              <span
                class="ui-popup-col__controls-sync"
                @click="reset"
              ><i class="fas fa-sync-alt" />
                {{ $t('reports.other.reset_to_defaults') }}
              </span>
            </div>
            <div class="ui-popup-col__controls-block">
              <UiButton
                class="ui-popup-col__controls-button"
                size="big"
                type="negative"
                icon="times"
                @click="cancel"
              >
                {{ $t('reports.other.close') }}
              </UiButton>
              <UiButton
                class="ui-popup-col__controls-button"
                :disabled="actionsDisabled"
                size="big"
                filled
                icon="check"
                @click="save"
              >
                {{ $t('reports.other.save') }}
              </UiButton>
            </div>
          </slot>
        </div>
      </div>
      <div class="ui-popup-col__overlay" />
    </div>
  </Transition>
</template>

<script>
export default {
  name: 'UiPopupCol',
  props: {
    title: {
      type: String,
      default: 'Title',
    },
    width: {
      type: Number,
      default: 600,
    },
    actionName: {
      type: String,
      default: 'Save',
    },
    actionsDisabled: {
      type: Boolean,
      default: false,
    },
    escClose: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['cancel', 'reset', 'save', 'close', 'open'],
  data() {
    return {
      isOpen: false,
    };
  },
  created() {

  },
  mounted() {
    window.addEventListener('keyup', this.escHandler);
  },
  beforeUnmount() {
    window.removeEventListener('keyup', this.escHandler);
  },
  methods: {
    open() {
      this.isOpen = true;
      this.$emit('open');
    },
    close() {
      this.isOpen = false;
      this.$emit('close');
    },
    save() {
      this.$emit('save');
    },
    reset() {
      this.$emit('reset');
    },
    cancel() {
      this.$emit('cancel');
    },
    escHandler(e) {
      if (!this.escClose) return;
      if (e.key === 'Escape' && this.isOpen) {
        this.close();
        this.$emit('cancel');
      }
    },
  },
};
</script>

<style lang="scss">
.ui-popup-col{
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 3000;

  &__overlay{
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    opacity: 0.5;
    background-color: #303634;
    z-index: 901;
  }

  &__content {
    display: flex;
    flex-direction: column;
    z-index: 902;
    top: 8vh;
    border-radius: 8px;
    background-color: white;
    box-sizing: border-box;
    overflow: hidden;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
  }

  &__head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 24px 16px;
    border-bottom: 1px solid #eaeaea;
    font-size: 20px;
    line-height: 20px;
    font-weight: 500;
    color: #303634;
  }
  &__head-icon{
    color: #303634;
    cursor: pointer;
  }

  &__body{
    padding: 16px 24px;
  }

  &__controls{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 12px;
    padding: 16px 24px;
    border-top: 1px solid #eaeaea;
  }
  &__controls-button {
    margin-left: 8px;
  }
  &__controls-sync {
    font-size: 12px;
    color: var(--text-negative);
    &:hover{
      cursor: pointer;
    }
    i{
      margin-right: 6px;
      font-size: 12px;
    }
  }

  &.fade-enter-active, &.fade-leave-active{
    transition: all .4s;
    .wrapper{
      transition: all .4s;
    }
  }
  &.fade-enter, &.fade-leave-to{
    opacity: 0;
    .wrapper{
      transform: translateY(20px);
    }
  }
}
</style>
